/**
 * Auto-reload on `ChunkLoadError` — recovers from the stale-client-
 * after-deploy scenario where the currently-running `main.js`
 * references lazy-loaded chunk URLs that no longer exist on the CDN.
 *
 * Guard against reload loops: only reload once per session. If the
 * second load also fails, something else is wrong and we want the
 * error to surface rather than busy-loop.
 */

const RELOAD_GUARD_KEY = "ev_chunk_reload_at";
const RELOAD_COOLDOWN_MS = 60_000; // 1 minute

function isChunkError(msg: unknown): boolean {
  const s = typeof msg === "string" ? msg : (msg as any)?.message || "";
  return /ChunkLoadError|Loading chunk [\w-]+ failed|Loading CSS chunk/i.test(s);
}

function tryReload() {
  let last = 0;
  try {
    last = Number(sessionStorage.getItem(RELOAD_GUARD_KEY) || "0");
  } catch {}
  if (Date.now() - last < RELOAD_COOLDOWN_MS) {
    // Recent reload didn't solve it — let the error propagate.
    return;
  }
  try {
    sessionStorage.setItem(RELOAD_GUARD_KEY, String(Date.now()));
  } catch {}
  window.location.reload();
}

export function installChunkErrorRecovery() {
  window.addEventListener("error", (e) => {
    if (isChunkError(e.message) || isChunkError(e.error)) tryReload();
  });
  window.addEventListener("unhandledrejection", (e) => {
    if (isChunkError(e.reason)) tryReload();
  });
}
